<template>
  <CBadge v-if="isDeleted" color="danger" class="deleted-record-badge">{{ $t('product.deleted') }}</CBadge>
</template>

<script>
export default {
  name: 'DeletedRecordBadge',
  props: {
    record: { type: Object, default: null },
    deleted: { type: Boolean, default: false },
  },
  computed: {
    isDeleted() {
      const flag = this.record?.is_deleted;
      return this.deleted || flag === true || flag === 1 || flag === '1' || Boolean(this.record?.deleted_at);
    },
  },
};
</script>

<style scoped>
.deleted-record-badge { flex-shrink: 0; white-space: nowrap; vertical-align: middle; }
</style>
